import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fc6e037"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "main__wrapper" }
const _hoisted_3 = { style: {"padding":"10px 0 0 0"} }

import { IonPage, IonContent, IonTitle, IonToolbar, IonHeader, IonAlert, } from '@ionic/vue';
import { useRoute } from 'vue-router';
import useScanner from '@/composable/useScanner';
import { BasicSliderButton, BasicLoading, } from '@components/basic';
import DeliveryTypeSelect from '@components/delivery/DeliveryTypeSelect.vue'
import DeliveryScannedList from '@components/delivery/DeliveryScannedList.vue';
import useDocumentArticles from '@/composable/useDocumentArticles';
import useScanningList from '@/composable/useScanningList'
import useCreateDeliveryDocument from './_inner/useCreateDeliveryDocument'
import { computed } from 'vue';
import useChangeArticleQuantityAlert from "@/composable/useChangeArticleQuantityAlert"
import useDeleteSingleArticle from '@/composable/useDeleteSingleArticle';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateDeliveryDocumentView',
  setup(__props) {

const documentId = computed(() => Number(route.params.id))
const documentArticles = computed(() => getArticles(document.data))

const route = useRoute()

const { getArticles } = useDocumentArticles()

const {
    isLoading: isLoadingUseScanningList,
    scannedArticles,
    setArticleQuantity,
    deleteArticleQuantity,
    addProductToScannedList,
} = useScanningList(documentArticles)

const {
    document,
    place,
    selectedType,
    isLoading: isLoadingCreateDeliveryDocument,
    endScanArticlesAction,
    scanPlaceSubmit,
    deliveryTypeBlocked,
} = useCreateDeliveryDocument(documentId)

const {
    alertButton,
    alertInputs,
    isOpenAlert,
    closeChangeQuantityAlert,
    openChangeQuantityAlert
} = useChangeArticleQuantityAlert(documentArticles, (code: string, quantity: number) => setArticleQuantity(code, quantity));
const {
    alertButton: deleteSingleAlertButton,
    closeDeleteSingleArticleAlert,
    isOpenAlert: isOpenDeleteSingleAlert,
    openDeleteSingleArticleAlert
} = useDeleteSingleArticle(documentArticles, (code: string) => deleteArticleQuantity(code));

const handleAcceptDelivery = () => endScanArticlesAction()
const isViewLoading = computed(() => isLoadingCreateDeliveryDocument.value || isLoadingUseScanningList.value)

const handleOnScan = (code: string) => {
    if (!place.activeAlert) {
        addProductToScannedList(code)
    } else {
        scanPlaceSubmit(code, scannedArticles)
    }
}

useScanner({
    onScan(code) {
        handleOnScan(code)
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonAlert), {
        inputs: _unref(alertInputs),
        buttons: _unref(alertButton),
        isOpen: _unref(isOpenAlert),
        header: "Change quantity of scanned product.",
        onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (_unref(closeChangeQuantityAlert)()))
      }, null, 8, ["inputs", "buttons", "isOpen"]),
      _createVNode(_unref(IonAlert), {
        buttons: _unref(deleteSingleAlertButton),
        isOpen: _unref(isOpenDeleteSingleAlert),
        header: "Are you sure you want to remove that product from document?",
        onDidDismiss: _cache[1] || (_cache[1] = ($event: any) => (_unref(closeDeleteSingleArticleAlert)()))
      }, null, 8, ["buttons", "isOpen"]),
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("WMS | Accept delivery")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          (_unref(isViewLoading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(BasicLoading), { "is-loading": _unref(isViewLoading) }, null, 8, ["is-loading"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createVNode(DeliveryTypeSelect, {
                disabled: _unref(deliveryTypeBlocked) || _unref(isViewLoading),
                modelValue: _unref(selectedType),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(selectedType) ? (selectedType).value = $event : null))
              }, null, 8, ["disabled", "modelValue"])
            ]),
            _createVNode(DeliveryScannedList, {
              onOpenChangeQuantityAlert: _unref(openChangeQuantityAlert),
              onDeleteSingleArticle: _unref(openDeleteSingleArticleAlert),
              "scanned-articles": _unref(scannedArticles),
              "is-loading": _unref(isViewLoading)
            }, null, 8, ["onOpenChangeQuantityAlert", "onDeleteSingleArticle", "scanned-articles", "is-loading"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(BasicSliderButton), {
                onOnSuccess: handleAcceptDelivery,
                disabled: !_unref(selectedType) || _unref(isViewLoading) || _unref(scannedArticles).length < 1,
                size: 48
              }, null, 8, ["disabled"])
            ]),
            _createVNode(_unref(IonAlert), {
              isOpen: _unref(place).activeAlert,
              header: "Scan place code."
            }, null, 8, ["isOpen"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})